<div class="feature"><a href="https://portal.wildflowerhealth.net/affiliate-care/b88eb04" target="wildflower"><img class="right"
    style="float:inline-end" width="100px" src="assets/images/AcceptingCigna.png" alt="" /></a>
    <h3><a href="https://portal.wildflowerhealth.net/affiliate-care/b88eb04" target="wildflower">Check your insurance coverage with Cigna.</a></h3>
    <p>I am an in network provider with Cigna.  Please verify your coverage and reach out today.</p>
</div>